function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.667,
  width: 40,
  height: 40,
  rx: 6,
  fill: "#7F8DE1"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.267 20.44c.04-.84-.56-1.08-.8-1.08h-8.72c-.76 0-.88.8-.88.88v9.36h10.4v-9.16zm-6 6.72c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.08c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm4 4.08c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.08c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.267 16.12v-4.64c.04-.84-.56-1.08-.8-1.08H9.947c-.76 0-.88.8-.88.88V29.6h10.4V17.88s0-.96.88-.96h3.16c.44 0 .76-.48.76-.8zm-10.8 10.64c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.12c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.08c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.08c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm4.4 12.28c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.12c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.08c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm0-4.08c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8zm4.4 0c0 .44-.36.8-.8.8h-.8c-.44 0-.8-.36-.8-.8v-.8c0-.44.36-.8.8-.8h.8c.44 0 .8.36.8.8v.8z",
  fill: "#fff"
});

var SvgSfAccount = function SvgSfAccount(props) {
  return React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgSfAccount;